export const FormatItalicIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M15.8333 3.33331H8.33329M11.6666 16.6666H4.16663M12.5 3.33331L7.49996 16.6666"
      stroke="#8A8A8E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
